import React from 'react';
import { Hero } from './components/Hero';
import { ParaQuienEs } from './components/ParaQuienEs';
import { VideoDemo } from './components/VideoDemo';
import { VideoInterior } from './components/VideoInterior';
import { Comparativa } from './components/Comparativa';
import { QueIncluye } from './components/QueIncluye';
import { ValorPercibido } from './components/ValorPercibido';
import { Beneficios } from './components/Beneficios';
import { Testimonios } from './components/Testimonios';
import { FAQ } from './components/FAQ';
import { OfertaFinal } from './components/OfertaFinal';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { UpsellProvider } from './components/UpsellContext';
export function App() {
  return <UpsellProvider data-id="element-0">
      <main className="min-h-screen bg-cream font-sans selection:bg-yellow/40 selection:text-violet" data-id="element-1">
        <Hero data-id="element-2" />
        <ParaQuienEs data-id="element-3" />
        <VideoDemo data-id="element-4" />
        <QueIncluye data-id="element-5" />
        <VideoInterior data-id="element-6" />
        <Comparativa data-id="element-7" />
        <Beneficios data-id="element-8" />
        <Testimonios data-id="element-9" />
        <ValorPercibido data-id="element-10" />
        <FAQ data-id="element-11" />
        <OfertaFinal data-id="element-12" />
        <Footer data-id="element-13" />
        <StickyCTA data-id="element-14" />
      </main>
    </UpsellProvider>;
}